<template>
  <div
    v-if="bottomBarStatus === -1 || bottomBarStatus === -2"
    class="reconnect-box"
  >
    <div class="alert-message">
      <p class="dim">{{ t('end_of_call_by_connecting_status') }}</p>
      <a @click="handleReconnect">{{ t('reconnect_call') }}</a>
    </div>
  </div>

  <div
    v-if="
      socketStore.socketState !== SocketState.RETRY_FAILED &&
      bottomBarStatus === 1
    "
    class="reconnect-box"
  >
    <LoadingIcon />
    <div class="alert-message">
      <p class="dim" v-if="bottomBarStatus === 1">{{}}</p>
    </div>
  </div>
  <p v-else-if="bottomBarStatus === 2" class="dim alert-message">
    {{ t('alert_message_end_call') }}
  </p>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import LoadingIcon from '@/components/icons/IconLoading.vue';
import { SocketState, useSocketStore } from '@/stores/socket';

const socketStore = useSocketStore();
const { t } = useI18n();
const { bottomBarStatus, handleReconnect } = defineProps<{
  bottomBarStatus: number;
  handleReconnect: () => void;
}>();
</script>

<style scoped lang="scss">
.alert-message {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0.5rem;
  white-space: nowrap;
}

.reconnect-box {
  width: 100%;
  gap: 0rem;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

@media (min-width: 768px) {
  .alert-message {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
  }
}
</style>
